import {
  cva
} from "../../../chunk-6A7LB5UJ.mjs";
import "../../../chunk-QJVDQ4DQ.mjs";
import "../../../chunk-D57E6H3M.mjs";

// src/components/primitive/Spinner/Spinner.tsx
import { useComponentsTranslation } from "../../../i18n/useComponentsTranslation.mjs";
import { jsx } from "react/jsx-runtime";
var spinnerVariants = cva("buyscout-spinner", {
  variants: {
    size: {
      sm: "buyscout-spinner--sm",
      md: "buyscout-spinner--md",
      lg: "buyscout-spinner--lg"
    },
    tone: {
      ink: "",
      current: "buyscout-spinner--tone-current"
    }
  },
  defaultVariants: {
    size: "md",
    tone: "ink"
  }
});
function Spinner({
  ref,
  ...props
}) {
  const {
    size,
    tone,
    className,
    ariaLabel,
    "aria-label": ariaLabelProp,
    ...rest
  } = props;
  const { t } = useComponentsTranslation();
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref,
      className: spinnerVariants({ size, tone, className }),
      role: "progressbar",
      "aria-label": ariaLabelProp ?? ariaLabel ?? t("spinner.loading"),
      ...rest
    }
  );
}
Spinner.displayName = "Spinner";
export {
  Spinner
};
//# sourceMappingURL=Spinner.mjs.map